import { shopPrefix } from '../../config';
import { http } from '../axios';
import { ProductFilter } from '../../store/api';

const endpoint = `${shopPrefix}/v1/librarymanaged/productgroups/:productGroupId/bulk/shoppingcart/filter/copy`;

type BulkQuantityFilterRequest = {
    amount: number;
    excludedProductIds: Array<string>;
    filterRequest: ProductFilter;
};

export const addProductsToGroupFromCartByFilter = (productGroupId: number, body: BulkQuantityFilterRequest) => {
    return http
        .put<void>(endpoint, body, {
            pathParams: { productGroupId }
        })
        .then(res => res.data);
};
